// Questions Module Constants
import { 
  Clock, 
  MessageSquare, 
  Copy, 
  Ban, 
  CheckCircle, 
  AlertTriangle,
  HelpCircle,
  Paperclip,
  BarChart3,
  DollarSign,
  Building,
  Folder,
  LayoutList
} from 'lucide-react';

// Status Configuration
export const STATUS_CONFIG = {
  open: {
    bg: 'bg-orange-100',
    text: 'text-orange-700',
    icon: Clock,
    label: 'Open'
  },
  answered: {
    bg: 'bg-blue-100',
    text: 'text-blue-700',
    icon: MessageSquare,
    label: 'Answered'
  },
  duplicate: {
    bg: 'bg-purple-100',
    text: 'text-purple-700',
    icon: Copy,
    label: 'Duplicate'
  },
  out_of_scope: {
    bg: 'bg-gray-100',
    text: 'text-gray-700',
    icon: Ban,
    label: 'Out of Scope'
  },
  closed: {
    bg: 'bg-green-100',
    text: 'text-green-700',
    icon: CheckCircle,
    label: 'Closed'
  }
};

// Priority Configuration
export const PRIORITY_CONFIG = {
  high: {
    bg: 'bg-red-100',
    text: 'text-red-700',
    label: 'High Priority',
    icon: AlertTriangle
  },
  medium: {
    bg: 'bg-yellow-100',
    text: 'text-yellow-700',
    label: 'Medium Priority',
    icon: Clock
  },
  low: {
    bg: 'bg-green-100',
    text: 'text-green-700',
    label: 'Low Priority',
    icon: CheckCircle
  },
  normal: {
    bg: 'bg-gray-100',
    text: 'text-gray-700',
    label: 'Normal Priority',
    icon: Clock
  }
};

// Module Configuration
export const MODULE_CONFIG = {
  dataroom: {
    label: 'Dataroom',
    icon: Folder,
    color: 'text-blue-600'
  },
  capraise: {
    label: 'CapRaise',
    icon: DollarSign,
    color: 'text-green-600'
  },
  equity: {
    label: 'Equity',
    icon: Building,
    color: 'text-purple-600'
  },
  general: {
    label: 'General',
    icon: HelpCircle,
    color: 'text-gray-600'
  }
};

// Navigation Items - Questions Module
export const NAVIGATION_ITEMS = [
  { id: '/questions/dealrooms', icon: Folder, label: 'Dealroom Questions' },
  { id: '/questions/support', icon: HelpCircle, label: 'Support Questions' },
  { id: '/questions/attachments', icon: Paperclip, label: 'Attachments' },
  { id: '/questions/bulk-actions', icon: BarChart3, label: 'Bulk Actions' },
];

// Question Categories - Separated by Use Case
export const SUPPORT_CATEGORIES = [
  'Account',
  'Billing',
  'Technical',
  'Feature Request',
  'Bug Report',
  'General'
];

export const DEALROOM_CATEGORIES = [
  'Document Access',
  'File Organization',
  'Permission Issues',
  'Upload Problems',
  'Download Issues',
  'General'
];

// Legacy - kept for backwards compatibility
export const QUESTION_CATEGORIES = {
  general: SUPPORT_CATEGORIES,
  technical: ['Technical', 'Integration', 'Performance', 'Security'],
  financial: ['Financial', 'Billing', 'Payment', 'Refund'],
  legal: ['Legal', 'Compliance', 'Terms', 'Privacy'],
  billing: ['Billing', 'Payment', 'Subscription', 'Refund'],
  dataroom: DEALROOM_CATEGORIES
};

// Default Module Options
export const MODULE_OPTIONS = [
  { value: 'dataroom', label: 'Dataroom', icon: Folder },
  { value: 'equity_manager', label: 'Equity', icon: Building },
  { value: 'cap_raise', label: 'Capital Raising', icon: LayoutList },
  { value: 'general', label: 'General/App', icon: HelpCircle }
];

// User Roles
export const USER_ROLES = {
  CREATOR: 'creator',
  VIEWER: 'viewer',
  SUPER_ADMIN: 'super_admin'
};

// Permissions
export const PERMISSIONS = {
  CREATE: 'canCreate',
  MODERATE: 'canModerate',
  ADMIN: 'canAdmin'
};

// API Endpoints
export const API_ENDPOINTS = {
  QUESTIONS: '/api/questions',
  CATEGORIES: '/api/categories',
  ATTACHMENTS: '/api/attachments',
  STATS: '/api/stats'
};

// Default Values
export const DEFAULTS = {
  QUESTION_LIMIT: 20,
  MAX_ATTACHMENTS: 5,
  RESPONSE_LIMIT: 1000,
  RETRY_ATTEMPTS: 3
};

